import errorTransformer from '../shared/transformers/errorTransformer';
import TwoStepVerification from './resources';
import normalizeNumbers from '@/utils/normalizeNumbers';

export default {
  getStatus() {
    return TwoStepVerification.getStatus()
      .then(({ body }) => body)
      .catch(errorTransformer);
  },
  setup() {
    return TwoStepVerification.setup({}, {})
      .then(({ body }) => body)
      .catch(errorTransformer);
  },
  enable(otp) {
    return TwoStepVerification.enable({}, { otp: normalizeNumbers(otp) })
      .then(({ body }) => body)
      .catch(errorTransformer);
  },
  disable(otp) {
    return TwoStepVerification.disable({}, { otp: normalizeNumbers(otp) })
      .then(({ body }) => body)
      .catch(errorTransformer);
  },
};
